<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: gray;
      width: 100vw;
      height: 100vh;
      gap: 0.5rem;
    "
  >
    <template v-if="!link"> <i class="el-icon-loading" />加载中 </template>
    <template v-else-if="isError">
      <span>链接异常，请重新点击链接</span>
    </template>
    <template v-else>
      <span>正在拉起...</span>
      <el-button type="primary" @click="handleJump" size="medium">立即跳转</el-button>
    </template>
  </div>
</template>

<script>
import request from "@utils/request";
export default {
  data() {
    return {
      link: "",
      isError: false,
    };
  },
  methods: {
    getLink() {
      const url = `https://customer.hortorgames.com/customer/api/v1/gs/new/ticket/community/url`;
      const params = {
        gameId: this.$route.query.gameId,
      };
      request
        .get(url, {
          params,
        })
        .then((res) => {
          if (res.meta.errCode == 0) {
            this.link = res.data || "";
            window.location.replace(this.link);
          } else throw new Error(res.meta.errMsg);
        })
        .catch((err) => {
          this.isError = true;
          console.error(err);
        });
    },
    handleJump() {
      window.location.replace(this.link);
    },
  },
  mounted() {
    this.getLink();
  },
};
</script>

<style scoped></style>

